import useAppSelector from '../../../store/hooks/useAppSelector'
import Modal from '../../app/components/modal/Modal'
import { productsIsProductUpsellModalOpenSelector } from '../store/productSelectors'
import ConfigureUpsellGroupForm from '../forms/upsellGroups/ConfigureUpsellGroupForm'
import { ConfigureProductUpsellGroupFormState } from '../types'

import styles from './ProductDetailsModal.module.scss'

type ProductUpsellModalProps = {
  onSubmit: (data: ConfigureProductUpsellGroupFormState) => void
}

export default function ProductUpsellModal({
  onSubmit,
}: ProductUpsellModalProps) {
  const isModalVisible = useAppSelector(
    productsIsProductUpsellModalOpenSelector,
  )

  // Backdrop and Escape mean "Continue without": the
  // product the customer configured always goes into the cart
  function handleContinueWithout() {
    onSubmit({ upsellGroupId: '', selectedUpsellGroups: [] })
  }

  return (
    <Modal
      isOpen={isModalVisible}
      onClose={handleContinueWithout}
      className={styles.modal}
      mobileModalMode="bottom-sheet"
      hideClose
      pinBodyOnMobile
    >
      <div className={styles.modalBody}>
        <ConfigureUpsellGroupForm onSubmit={onSubmit} />
      </div>
    </Modal>
  )
}
